import React from "react";
import DocSections from "@/pages/DocSections";

export default function ProgramIdentity() {
  return (
    <DocSections
      title="Program Identity"
      subtitle="The DNA of your football program"
      endpoint="/program-identity"
      testid="program-identity-page"
    />
  );
}
